/** Focus an ion-input or ion-textarea by formControlName or id (Ionic 7+ shadow DOM). */
export async function focusFormControl(
  root: HTMLElement,
  name: string,
  match: 'formControlName' | 'id' = 'formControlName'
): Promise<void> {
  const selector = `[${match}="${name}"]`;
  const ionInput = root.querySelector(`ion-input${selector}`) as HTMLIonInputElement | null;
  if (ionInput?.setFocus) {
    await ionInput.setFocus();
    return;
  }
  const ionTextarea = root.querySelector(`ion-textarea${selector}`) as HTMLIonTextareaElement | null;
  if (ionTextarea?.setFocus) {
    await ionTextarea.setFocus();
  }
}
